import isdlAccessInstance from './isdlAccessInstance';

export let BallTests = [];
const CUSTOM_TEST_OPTION = { value: 'add-new-test', label: 'Add a New Test' };

//GET

//ConstantCategories_GetCategory
export const getCategory = async (category) => await isdlAccessInstance.constantsData.GetCategory(category);

const mapBallTestToOption = (test) => {
    if (typeof test === 'string') {
        return { value: test, label: test };
    }

    if (!test || typeof test !== 'object') {
        return null;
    }

    const value = test.value ?? test.Value ?? test.systemName ?? test.SystemName ?? test.id ?? test.Id ?? test.name ?? test.Name ?? test.testName ?? test.TestName ?? test.description ?? test.Description;
    const label = test.label ?? test.Label ?? test.displayName ?? test.DisplayName ?? test.name ?? test.Name ?? test.testName ?? test.TestName ?? test.description ?? test.Description ?? test.value ?? test.Value ?? test.systemName ?? test.SystemName ?? test.id ?? test.Id;

    if (!value || !label) {
        return null;
    }

    return {
        value: String(value),
        label: String(label),
    };
};

const extractBallTestsArray = (payload) => {
    if (Array.isArray(payload)) {
        return payload;
    }

    if (!payload || typeof payload !== 'object') {
        return [];
    }

    if (Array.isArray(payload.fieldConstants)) {
        return payload.fieldConstants;
    }

    const candidateArrays = [
        payload.data,
        payload.items,
        payload.value,
        payload.values,
        payload.results,
        payload.records,
        payload.tests,
        payload.BallTests,
        payload.fieldConstants,
    ];

    const firstArray = candidateArrays.find(Array.isArray);
    if (firstArray) {
        return firstArray;
    }

    return [payload];
};

export async function GetBallTests(){
    if(BallTests && BallTests.length === 0){
        const rawTests = await getCategory('BallTest');
        const extractedTests = extractBallTestsArray(rawTests);
        const normalizedTests = extractedTests
            .map(mapBallTestToOption)
            .filter((test) => test !== null);

        const uniqueTests = normalizedTests.filter((test, index, tests) =>
            tests.findIndex((candidate) => candidate.value === test.value) === index
        );

        if (uniqueTests.length === 0) {
            console.warn('GetBallTests returned no mappable records for category "BallTest". Raw payload:', rawTests);
        }

        BallTests = [
            CUSTOM_TEST_OPTION,
            ...uniqueTests,
        ];
    }

    return BallTests;
}
